import React from 'react'
import styled from '@emotion/styled'
import { calcRem, breakpointMax } from 'component-library/__styling/style-functions'

const StyledRoadSafetyLogo = styled('img')({
    position: 'absolute',
    right: 0,
    top: calcRem(-45),
    height: calcRem(40),

    [breakpointMax('sm')]: {
        display: 'none',
    },
})

export const RoadSafetyLogo: React.FC<{}> = () => (
    <StyledRoadSafetyLogo
        src={require('./rsc-logo-with-state-govt-crest-rgb-80.png')}
        alt="Live scores brought to you by The Road Safety Commission"
        height="34"
    />
)
